import { ClientBriefDto, ClientDto, ClientType } from '../services/api/sharedTypes/Client'
import { ContactDto } from '../services/api/sharedTypes/Contact'

export const convertClientDtoToClientBriefDto = (client: ClientDto): ClientBriefDto => {
    return {
        id: client.id,
        name: client.name,
        companyRegistrationNumber: client.companyRegistrationNumber,
        valueAddedTaxIdentificationNumber: client.valueAddedTaxIdentificationNumber,
        note: client.note,
        contactCount: client.contacts.length,
        eventCount: client.events.length,
        notificationCount: client.notifications.length,
        clientType: client.clientType,
        profit: client.events.reduce((acc, event) => acc + event.profit, 0),
        address: client.address,
        lastModifiedAt: client.lastModifiedAt,
        createdAt: client.createdAt,
        emailMessageSwitches: client.emailMessageSwitches,
        contacts: client.contacts,
    }
}

export const getEmptyClientObject: () => ClientDto = () => {
    return {
        id: '0',
        createdAt: new Date(),
        address: {
            city: '',
            street: '',
            zip: '',
        },
        name: '',
        lastName: '',
        companyRegistrationNumber: '',
        valueAddedTaxIdentificationNumber: '',
        note: '',
        profit: 0,
        contacts: [getEmptyContactPersonObject()],
        events: [],
        notifications: [],
        clientType: ClientType.Citizen,
        lastModifiedAt: new Date(),
        emailMessageSwitches: {
            '0': true,
            '1': true,
            '2': true,
            '3': true,
            '4': true,
            '5': true,
            '6': true,
            '7': true,
            '8': true,
        },
    }
}

export const getEmptyContactPersonObject: () => ContactDto = () => {
    return {
        name: '',
        lastName: '',
        phone: '',
        email: '',
    }
}

export const convertStringToClientType = (data: number) => {
    if (data === ClientType.Citizen) return ClientType.Citizen
    if (data === ClientType.LegalEntity) return ClientType.LegalEntity
    if (data === ClientType.Individual) return ClientType.Individual
    return ClientType.NotSet
}

export const convertClientTypeToString = (data: ClientType) => {
    if (data === ClientType.Citizen) return 'Občan'
    if (data === ClientType.LegalEntity) return 'Právnická osoba'
    if (data === ClientType.Individual) return 'Fyzická osoba'
    return 'Není nastaveno'
}

export const convertClientTypeToTableString = (data: ClientType) => {
    if (data === ClientType.Citizen) return 'Občan'
    if (data === ClientType.LegalEntity) return 'PO'
    if (data === ClientType.Individual) return 'FO'
    return 'Není nastaveno'
}
